import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseContainer from '../baseContainers/BaseContainer';
import {CustomMessages} from '../components/CustomMessages';
import BlockUi from '../components/waitPanel/BlockUi';
import AccountService from '../services/AccountService';
import IncomeListContainer from './IncomeListContainer';
class BalancePrepaidContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.accountService = new AccountService();
        this.onAfterGetList = this.onAfterGetList.bind(this);
        this.state = {
            activeIndex: 0,
            inProgressCount: 0,
            draftsCount: 0,
            balance: {},
            lastAmount: 0,
        };
    }
    onAfterGetList(list) {
        if (list?.length > 0) {
            this.setState({lastAmount: list[0].amount});
        }
    }
    componentDidMount() {
        const {t} = this.props;
        super.componentDidMount();
        this.blockUi();
        this.accountService
            .getBalance(true)
            .then((balance) => {
                this.setState({balance}, () => {
                    this.unblockUi();
                });
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.getBalanceError'));
            });
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }
    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    render() {
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    {!!this.state.blocking || !!this.state.loading ? null : this.renderView()}
                </BlockUi>
            </React.Fragment>
        );
    }
    renderView() {
        const {t} = this.props;

        const fieldsList = [
            {label: t(`incomeList.lastPrepaidIncome`), value: this.state.lastAmount},
            {label: t(`balance.remainingLimit`), value: this.state.balance.remainingLimit},
        ];
        return (
            <div className='balance-details-site'>
                <div className='header-content'>
                    <span className='header-welcome header-welcome-label'>{t('balance.detailsHeader')}</span>
                </div>

                <div className='balance-details-header'>
                    <div className='row balance-details-row'>
                        {fieldsList.map((field) => {
                            return (
                                <div className='col-md-3 col-sm-6 '>
                                    <div className='balance-value'>
                                        <div className='balance-input-header'>
                                            <span className='label'>{field.label}</span>
                                            <span className={`value ${field === 'remainingLimit' ? 'bold' : ''}`}>
                                                <NumberFormat
                                                    value={!!field.value ? field.value : 0}
                                                    className='value'
                                                    displayType={'text'}
                                                    thousandSeparator=' '
                                                    decimalSeparator=','
                                                    fixedDecimalScale
                                                    decimalScale={2}
                                                    suffix={` ${t('currency.pln')}`}
                                                    renderText={(value, props) => value}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className='container-fluid'>
                    <IncomeListContainer
                        onAfterGetList={this.onAfterGetList}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.showMessage}
                        embedded
                        _isMounted={this._isMounted}
                    />
                </div>
            </div>
        );
    }
}
BalancePrepaidContainer.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
};

BalancePrepaidContainer.propTypes = {
    newUrl: PropTypes.string,
    viewMode: PropTypes.string,
};

export default withTranslation()(BalancePrepaidContainer);
